export default __webpack_public_path__ + "static/nbox-quick-2d2bf827879c8da153cff93591d292cb.avif";